import { validator } from "@/utils/validator";

export const renewVisaApplicationInformationSchema = validator.object().shape({
  applicationInformation: validator
    .array()
    .of(
      validator.object().shape({
        renewVisaDocumentStepId: validator.number().required(),
        renewVisaDocumentId: validator.number().required(),
        applicationDate: validator.mixed().isDayjs().isSelection().label("申請日").required(),
        applicationNumber: validator.string().trim().emptyToNull().label("申請番号").required(),
      }),
    )
    .required(),
});
